// initialValues.js
const laganInitialValues = {
  start_time: "",
  end_time: "",
  name: "",
};
export default laganInitialValues;